import AjaxClass from '@/ajax'

export default class OrganizationService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getList (then, params) {
    return this.ajax.get('/organization', params, (data) => {
      return then(data)
    })
  }

  getItem (id, then, params) {
    return this.ajax.get('/organization/' + id, params, (data) => {
      return then(data)
    })
  }

  saveItem (item, update, then) {
    return this.ajax.post('/organization/save', {item: item, update: update}, (data) => {
      then(data)
    })
  }

  deleteItem (id, then) {
    return this.ajax.post('/organization/delete', {id: id}, (data) => {
      then(data)
    })
  }

  static getDefaultItem () {
    return {
      id: '',
      name: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/OrganizationService.js